import { render, staticRenderFns } from "./RestoreVersion.vue?vue&type=template&id=c71822ea&"
import script from "./RestoreVersion.vue?vue&type=script&lang=js&"
export * from "./RestoreVersion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports